// **** START CONFIG V1 (TO DEPRECATE) **** //

import ConfigService from './ConfigService';
import fetch from '../fetch';

let configService: ConfigService;
export const initConfig = async (env: string, path: string, e2eEnvNamespace?: string) => {
  configService = new ConfigService();

  const loadConfig = async (url: any) => {
    const response = await fetch(url);
    let responseText = await response.text();

    if (e2eEnvNamespace !== undefined) {
      // very hardcoded solution to support the new e2e environments, hardly relaying on the remote-dev config files
      const newApiHostname = `admin-api-${e2eEnvNamespace}.e2e.sunbit.dev`;
      responseText = responseText
        .replace(/api-master\.sunbit\.dev/g, newApiHostname)
        .replace(/admin-api\.master\.sunbit\.dev/g, newApiHostname);
    }

    return JSON.parse(responseText);
  };

  const defaultConfigPromise = new Promise<any>(async (resolve, reject) => {
    try {
      const defaultConfig = await loadConfig(path + '/default.json');
      console.log('default config is set');
      resolve(defaultConfig);
    } catch (error) {
      console.log('failed to read the default config');
      reject();
    }
  });

  const envConfigPromise = new Promise<any>(async (resolve) => {
    let envConfig;
    try {
      envConfig = await loadConfig(path + '/' + env + '.json');
      console.log(`env config [${env}] config is set`);
    } catch (error) {
      const subEnvConfig = env.replace(/.+-/g, '');
      envConfig = await loadConfig(path + '/' + subEnvConfig + '.json');
      console.log(`env config [${subEnvConfig}] config is set`);
    }

    resolve(envConfig);
  });

  // parallel the requests
  await Promise.all([defaultConfigPromise, envConfigPromise])
    .then((results) => {
      const [defaultConfig, envConfig] = results || [];

      if (!envConfig) console.log('Could not find environment config');
      // #        ? `https://admin-api-${process.env.E2E_ENV_NAME}.e2e.sunbit.dev`
      // #        : 'https://api-master.sunbit.dev',
      return configService.addConfig({ ...defaultConfig, ...envConfig });
    })
    .catch((error) => {
      console.error('Had error fetching configs', error);
    });

  return configService;
};

export const getConfig = () => {
  return configService;
};

// **** END CONFIG V1 **** //

// **** START CONFIG V2 **** //

export type Environment = 'dev' | 'local' | 'automation' | 'oregon-staging' | 'oregon-prod' | 'oregon-demo';

export type EnvOverrides<T> = {
  [key in Environment]?: Partial<T>;
};

declare const sunbitEnv: Environment;

export const configV2 = {
  createConfig<TConfig>(base: TConfig, envOverrides?: EnvOverrides<TConfig>): TConfig {
    if (sunbitEnv !== 'oregon-prod') console.log(`Sunbit Environment is: ${sunbitEnv}`);

    if (!envOverrides || !envOverrides[sunbitEnv]) {
      console.warn(`No env overrides found for ${sunbitEnv}.`);
      return base;
    }
    return { ...base, ...envOverrides[sunbitEnv] };
  },
};

/// How To Use?
/// in your app './config.ts' file have something like

// import { configV2 } from '@sunbit-dev/common/services/config';

// interface Config {
//   appName: string;
//   api: {
//     baseUrl: string;
//   };
// }

// export const config = configV2.createConfig<Config>(
//   {
//     appName: 'My App',
//     api: {
//       baseUrl: 'http://foo.bar',
//     },
//   },
//   {
//     'oregon-prod': {
//       api: {
//         baseUrl: 'http://foo.com',
//       },
//     },
//   }
// );

// **** END CONFIG V2 **** //
